import PropTypes from 'prop-types';
import React from 'react';
import { gql } from 'react-apollo';
import { toast } from 'react-toastify';
import TdAction from './TdAction';
import alertFirstGqlMsg from '../../alertFirstGqlMsg';

function Tr(props) {
  const {
    row,
    resource,
    cellFormatter,
    mutate,
    changeUrl,
    columns,
  } = props;

  const handleDelete = async () => {
    // eslint-disable-next-line no-alert
    const confirm = window.confirm('Are you sure you want to delete?');

    if (!confirm) {
      return;
    }

    const { crudMapping, uniqKey } = resource;
    const uniqKeyQuery = { [uniqKey]: row[uniqKey] };

    const deleteMutation = gql`
      mutation ${crudMapping.delete}($${uniqKey}: String!) {
        ${crudMapping.delete}(${uniqKey}: $${uniqKey})
      }
    `;

    try {
      await mutate({
        mutation: deleteMutation,
        variables: uniqKeyQuery,
      });

      changeUrl();
      toast.success('Delete Success');
    } catch (error) {
      alertFirstGqlMsg(error);
    }
  };

  const tdFieldElements = columns.map(({ columnName, type }) => {
    const defaultValues = {
      number: 0,
    };
    const value = row[columnName] !== null ? row[columnName] : defaultValues[type];
    return (
      <td key={columnName}>
        {cellFormatter(value, row, columnName)}
      </td>);
  });

  return (
    <tr>
      {tdFieldElements}
      <TdAction
        key="actions"
        resource={resource}
        row={row}
        handleDelete={handleDelete}
      />
    </tr>
  );
}

Tr.propTypes = {
  row: PropTypes.object.isRequired, // eslint-disable-line
  resource: PropTypes.object.isRequired, // eslint-disable-line
  cellFormatter: PropTypes.func.isRequired,
  mutate: PropTypes.func.isRequired,
  changeUrl: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Tr;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/ReadManyLib/Tr.js